"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Perform = void 0;
const flatbuffers = require("flatbuffers");
class Perform {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsPerform(bb, obj) {
        return (obj || new Perform()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsPerform(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Perform()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    type(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    assetId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    fixtureId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    allowedCountryCodes(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startPerform(builder) {
        builder.startObject(4);
    }
    static addType(builder, typeOffset) {
        builder.addFieldOffset(0, typeOffset, 0);
    }
    static addAssetId(builder, assetIdOffset) {
        builder.addFieldOffset(1, assetIdOffset, 0);
    }
    static addFixtureId(builder, fixtureIdOffset) {
        builder.addFieldOffset(2, fixtureIdOffset, 0);
    }
    static addAllowedCountryCodes(builder, allowedCountryCodesOffset) {
        builder.addFieldOffset(3, allowedCountryCodesOffset, 0);
    }
    static endPerform(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createPerform(builder, typeOffset, assetIdOffset, fixtureIdOffset, allowedCountryCodesOffset) {
        Perform.startPerform(builder);
        Perform.addType(builder, typeOffset);
        Perform.addAssetId(builder, assetIdOffset);
        Perform.addFixtureId(builder, fixtureIdOffset);
        Perform.addAllowedCountryCodes(builder, allowedCountryCodesOffset);
        return Perform.endPerform(builder);
    }
}
exports.Perform = Perform;
